import { Routes } from '@angular/router';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PageNotFoundComponent } from './pagenotfound.component';
//import { ViewlogComponent } from './account/viewlog/viewlog.component';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
    }
    , {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: '',
            //loadChildren: './dashboard/dashboard.module#DashboardModule'
            loadChildren: './account/login/login.module#LoginModule'
        }]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'createpassword',
            loadChildren: './account/login/login.module#LoginModule'
        }]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'consentform',
            loadChildren: './account/login/login.module#LoginModule'
        }]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'patientlist',
            loadChildren: './account/login/login.module#LoginModule'
        }]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'forgotpassword',
            loadChildren: './account/login/login.module#LoginModule'
        }]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [{
            path: 'mandateform',
            loadChildren: './account/login/login.module#LoginModule'
        }]
    }
    , {
        path: 'dashboard',
        component: AdminLayoutComponent,
        children: [{
            path: '',
            //loadChildren: './dashboard/dashboard.module#DashboardModule'
            component: DashboardComponent
        }, {
            path: 'dashboard',
            //loadChildren: './dashboard/dashboard.module#DashboardModule'
            component: DashboardComponent
        },
        {
            path: 'messages',
            loadChildren: './messageboard/messageboard.module#MessageBoardModule'
        },
        {
            path: 'clinical',
            loadChildren: './clinical/clinical.module#ClinicalModule'
        }
            ,
        {
            path: 'financials',
            loadChildren: './financials/financials.module#FinancialsModule'
        }
            ,
        {
            path: 'account',
            loadChildren: './account/account.module#AccountModule'
        }
            ,
        {
            path: 'patientforms',
            loadChildren: './forms/patientforms.module#FormModule'
        },
        {
            path: 'educationalresources',
            loadChildren: './educationalresources/educationalresources.module#EducationalResourceModule'
        },
        {
            path: 'documents',
            loadChildren: './documents/documents.module#DocumentsModule'
        },
        {
            path: 'clipboards',
            loadChildren: './clipboards/clipboards.module#ClipBoardsModule'
        },
        {
            path: 'immunotherapy',
            loadChildren: './immunotherapy/immunotherapy.module#ImmunotherapyModule'
        },
        {
            path: 'appointments',
            loadChildren: './appointments/requestappointments.module#RequestAppointmentModule'
        }
        ]
    }, { path: '**', component: PageNotFoundComponent }
];
